import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useStateWithCallbackLazy } from 'use-state-with-callback'
import { viewNews, newsType, listCommment, deleteComment } from '../Network/News'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { baseURL } from '../Network/Config'
import { Row, Col, Button, Pagination, Table } from 'react-bootstrap'
import Parser from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faComment, faTrash, faEdit, faCheck } from '@fortawesome/free-solid-svg-icons'
import { Container, Loading, HeaderTitle, ImagePreview } from '../Library'
import TypeBadge from './TypeBadge'
import dayjs from 'dayjs'
import { Doughnut, Pie } from 'react-chartjs-2'
import { setDocumentTitle } from '../AppTitle'
import { ModalContext } from '../Library/ModalContext'
import "./ViewNews.css"


function View() {
    const { news_id } = useParams()
    const modal = useContext(ModalContext)
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    const [isLoading, setLoading] = useState(false)
    const [title, setTitle] = useState("")
    const [subTitle, setSubTitle] = useState("")
    const [content, setContent] = useState("")
    const [publisher, setPublisher] = useState("")
    const [createDate, setCreateDate] = useState("")
    const [publishDate, setPublishDate] = useState("")
    const [expiredDate, setExpireDate] = useState("")
    const [newsImages, setNewsImages] = useState([])
    const [type, setType] = useState("")
    const [read, setRead] = useState([])
    const [unread, setUnread] = useState([])
    const [labelSet, setLabelSet] = useState([])
    const [choicesSet, setChoicesSet] = useState([])
    const [choicesDataset, setChoicesDataset] = useState([])
    const [registerPeople, setRegisterPeople] = useState([])
    const [maximumRegister, setMaximumRegister] = useState(0)
    const [isShowVisitor, setIsShowVisitor] = useState(false)
    const [acceptPeople, setAcceptPeople] = useState([])
    const [unacceptPeople, setUnAcceptPeople] = useState([])

    const previewImage = (key) =>{
        modal.setComponent(
            <ImagePreview
            initialKey={key}
            imagesSet={newsImages}
            isGetBaseURL
            />
        )
        modal.setHeader(lang.news_image)
        modal.setDark(true)
        modal.setShow(true)
    }

    const convertDate = (toDate) =>{
        let date = new Date(toDate)
        let formatted = dayjs(date).format("D MMMM YYYY H:mm")
        return formatted
    }

    useEffect(()=>{
        const fetchData = () =>{
            setLoading(true)
            viewNews(news_id,
                (data)=>{
                    let news = data.news
                    setDocumentTitle(news.title)
                    setTitle(news.title)
                    setSubTitle(news.subtitle)
                    setContent(news.content)
                    setPublisher(news.publisher)
                    setCreateDate(news.createdDate)
                    setPublishDate(news.publishDate)
                    setExpireDate(news.newsExpiredDate)
                    setIsShowVisitor(news.isShowVisitor)
                    setNewsImages(news.images)
                    setType(news.type)
                    if(news.type === newsType.NORMAL){
                        let read = data.result
                        let unread = data.resultUnRead
                        setRead(read)
                        setUnread(unread)
                    }else if(news.type === newsType.VOTE || news.type === newsType.QUIZ){
                        setChoicesDataset([])
                        var voteSet = []
                        var labelSet = []
    
                        news.choices.map((item)=>{
                            labelSet.push(item.choiceValue)
                            voteSet.push(data.result[item.id].length)
                            setChoicesDataset(oldArr=>[...oldArr, item])
                        })
                        setChoicesSet(voteSet)
                        setLabelSet(labelSet)
                    }else if(news.type === newsType.REGISTER){
                        setRegisterPeople(data.result)
                        setMaximumRegister(news.maximumRegister)
                    }else if(news.type === newsType.INFORM){
                        setAcceptPeople(data.result)
                        setUnAcceptPeople(data.resultUnAccept)
                    }
                    setLoading(false)
                },
                (error)=>{
                    setLoading(false)
                    notify.showNotify("Something wrong", error.message, 2)
                })
        }
        fetchData()
    },[])

    return (
        <Container topbarTitle={langCx.lang.sidebar.news}>
        { isLoading ? <Loading/>: null }
        <div id="view-news">
            <HeaderTitle
            title={title}
            description={
                <>
                <div className="desc">{subTitle}</div>
                <div style={{marginTop: 10}}>
                    <TypeBadge type={type}/>
                </div>
                </>
            }
            isShowBack
            backTo="/news"
            />
            <hr/>
            <div className="date-content">
                <DetailRow title={lang.create} value={convertDate(createDate)}/>
                <DetailRow title={lang.publish} value={convertDate(publishDate)}/>
                <DetailRow title={lang.expire_date} value={convertDate(expiredDate)}/>
                <DetailRow title={lang.publisher} value={publisher}/>
                { (new Date() > expiredDate) ?
                    <div style={{ color: 'red' }}>{lang.expired}</div>
                : null
                }
            </div>
            <hr/>
            <div className="news-content">
                <b>{lang.content}</b>
                {Parser(content)}
            </div>
            <hr/>
            <div>
                <b>{lang.news_image}</b>
                <Row style={{marginTop: 20}}>
                    { newsImages.map((item, key)=>
                    <Col key={key} xs={6} md={4} xl={3}>
                        <div className="news-image" onClick={()=>previewImage(key)}>
                            <img src={baseURL + item.imagePath} img={item.imagePath}/>
                        </div>
                        
                    </Col>
                    )}
                    
                </Row>
                { newsImages.length === 0 ?
                    <div style={{ color: 'gray' }}>
                        {lang.no_news_image}
                    </div>
                    : null
                }
            </div>
            <hr/>
            { type === newsType.NORMAL ?
            <>
            <Row>
                <Col lg={6}>
                    <b>{lang.number_read} ({read.length})</b>
                    <div className="read-container">
                        { read.map((item, key)=>
                        <UserItem
                        key={key}
                        name={item.firstName + " " + item.lastName}
                        email={item.email}
                        profileImage={item.profileImagePath}
                        />
                        )}
                    </div>
                </Col>
                <Col lg={6}>
                    <b>{lang.number_unread} ({unread.length})</b>
                    <div className="read-container">
                        { unread.map((item, key)=>
                        <UserItem
                        key={key}
                        name={item.firstName + " " + item.lastName}
                        email={item.email}
                        profileImage={item.profileImagePath}
                        />
                        )}   
                    </div>
                </Col>
            </Row>
            <hr/>
            </>
            : null
            }
            { type === newsType.VOTE ?
            <>
            <VoteSection 
            labelset={labelSet}
            dataset={choicesSet}
            />
            <hr/>
            </>
            : null
            }
            { type === newsType.REGISTER ?
            <>
            <RegisterSection
            registerPeople={registerPeople}
            maximum={maximumRegister}
            />
            <hr/>
            </>
            : null
            }
            { type === newsType.INFORM ?
            <>
            <InformSection
            accept={acceptPeople}
            unAccept={unacceptPeople}
            />
            <hr/>
            </>
            : null
            }
            { type === newsType.QUIZ ?
            <>
            <QuizSection
            labelset={labelSet}
            dataset={choicesSet}
            choiceset={choicesDataset}
            />
            <hr/>
            </>
            : null
            }
            <div>
                <b>{lang.comment}</b>
                <Comments newsId={news_id}/>
            </div>
        </div>
        </Container>
    )
}

function DetailRow({ title, value }){
    return(
        <div className="detail-row">
            <div className="title">{title} :&nbsp;&nbsp;</div>
            <div>{value}</div>
        </div>
    )
}

function RegisterSection(props){
    const registerList = props.registerPeople
    const maximum = props.maximum
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    return(
        <div>
            <b>{lang.number_of_people_register} ({registerList.length} / {maximum})</b>
            <div className="register-container">
                <Row>
                    { registerList.map((item,key)=>
                    <Col lg={6} xl={4} key={key}>
                        <div className="register-item">
                            <div className="image">
                                { item.profileImagePath !== "" && item.profileImagePath !== null ?
                                <img src={item.profileImagePath} alt={item.profileImagePath}/> :
                                <FontAwesomeIcon icon={faUserCircle} className="icon"/>
                                }
                            </div>
                            <div style={{marginLeft: 20}}>
                                <div className="title">{item.firstName + " " + item.lastName}</div>
                                <div className="email">{item.email}</div>
                                <div className="phone">{item.phone}</div>
                            </div>
                        </div>
                    </Col>
                    )}
                </Row>
                { registerList.length === 0 ?
                <div className="no-register">
                    <div>
                        <FontAwesomeIcon icon={faEdit} className="icon"/>
                    </div>
                    <div>{lang.no_register}</div>
                </div>
                : null
                }
            </div>
        </div>
    )
}

function InformSection(props){
    const accept = props.accept
    const unAccept = props.unAccept
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    const [selectedMenu, setSelectedMenu] = useState(0)

    const data = {
        labels: [lang.accept_inform, lang.unaccept_inform],
        datasets: [{
            data: [accept.length, unAccept.length],
            backgroundColor: ["#00275e", "lightgray"]
        }]
    }

    const MenuItem = (props) =>{
        return(
            <div className="menu" style={{
                backgroundColor: props.isSelected ? "#0275d8": null,
                color: props.isSelected ? "white": "black"
            }}
            onClick={props.onClick}
            >
                {props.title}
            </div>
        )
    }

    const PeopleItem = (props) =>{
        return(
            <div className="people-item">
                <div className="image">
                    { props.profile !== "" && props.profile !== null ?
                    <img src={props.profile} alt={props.profile}/> :
                    <FontAwesomeIcon icon={faUserCircle} className="icon"/>
                    }
                </div>
                <div style={{marginLeft: 20}}>
                    <div className="title">{props.name}</div>
                    <div className="desc">{props.email}</div>
                </div>
            </div>
        )
    }

    return(
        <div>
            <b>{lang.accept_inform}</b>
            <Row>
                <Col lg={6} xl={7}>
                    <div style={{marginBottom: 20}}>
                        <Doughnut
                        data={data}
                        />
                    </div>
                </Col>
                <Col lg={6} xl={5}>
                    <div className="inform-select">
                        <MenuItem 
                        isSelected={selectedMenu === 0 ? true:false}
                        title={lang.accept_inform}
                        onClick={()=>setSelectedMenu(0)}/>
                        <MenuItem 
                        isSelected={selectedMenu === 1 ? true:false}
                        title={lang.unaccept_inform}
                        onClick={()=>setSelectedMenu(1)}/>
                    </div>
                    <div className="inform-container">
                        { selectedMenu === 0 ?
                        accept.map((item, key)=>
                        <PeopleItem
                        key={key}
                        name={item.firstName + " " + item.lastName}
                        email={item.email}
                        profile={item.profileImagePath}
                        />
                        )
                        : 
                        unAccept.map((item, key)=>
                        <PeopleItem
                        key={key}
                        name={item.firstName + " " + item.lastName}
                        email={item.email}
                        profile={item.profileImagePath}
                        />
                        )
                    }
                    </div>
                </Col>
            </Row>
        </div>
    )
}

function VoteSection(props){
    const dataset = props.dataset
    const labelset = props.labelset
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    var colors = []

    function getRandomColorset() {
        var colorset = []
        var sets =[
            'rgba(255, 99, 132, 0.5)',
            'rgba(255, 159, 64, 0.5)',
            'rgba(255, 205, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(54, 162, 235, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(201, 203, 207, 0.5)'
        ]
        labelset.forEach((item)=>{
            var pickColor = sets[Math.floor(Math.random()*sets.length)]
            while(colorset.some((el)=>el === pickColor)){
                pickColor = sets[Math.floor(Math.random()*sets.length)]
            }
            colorset.push(pickColor)
        })
        colors = colorset
        return colorset
      }      
    
    useEffect(()=>{
    }, [])

    const data = {
        labels: labelset,
        datasets: [{
            label: lang.number_of_people_vote,
            data: dataset,
            backgroundColor: getRandomColorset(),
        }]
    };

    return(
        <div>
            <b>{lang.vote_result}</b>
            <Row>
                <Col lg={6} xl={7}>
                    <div style={{marginBottom:20}}>
                        <Pie 
                        data={data}
                        />
                    </div>
                </Col>
                <Col lg={6} xl={5}>
                    <div>
                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{lang.vote_choice}</th>
                                    <th>{lang.number_of_people_vote}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { dataset.map((item, key)=>
                                <tr key={key}>
                                    <td>
                                        <div className="vote-color"
                                        style={{backgroundColor: colors[key]}}>
                                        </div>
                                    </td>
                                    <td>{labelset[key]}</td>
                                    <td>{item}</td>
                                </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
            
        </div>
    )
}

function QuizSection(props){
    const dataset = props.dataset
    const labelset = props.labelset 
    const choiceset = props.choiceset
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news
    var colors = []

    function getRandomColorset() {
        var colorset = []
        var sets =[
            'rgba(255, 99, 132, 0.5)',
            'rgba(255, 159, 64, 0.5)',
            'rgba(255, 205, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(54, 162, 235, 0.5)',
            'rgba(153, 102, 255, 0.5)',
            'rgba(201, 203, 207, 0.5)'
        ]
        labelset.forEach((item)=>{
            var pickColor = sets[Math.floor(Math.random()*sets.length)]
            colorset.push(pickColor)
        })
        colors = colorset
        return colorset
      }      
    
    useEffect(()=>{
    }, [])

    const data = {
        labels: labelset,
        datasets: [{
            label: lang.number_of_people_vote,
            data: dataset,
            backgroundColor: getRandomColorset(),
        }]
    };

    return(
        <div>
            <b>{lang.quiz_result}</b>
            <Row>
                <Col lg={6} xl={7}>
                    <div style={{marginBottom:20}}>
                        <Pie 
                        data={data}
                        />
                    </div>
                </Col>
                <Col lg={6} xl={5}>
                    <div>
                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{lang.quiz_choice}</th>
                                    <th>{lang.answer}</th>
                                    <th>{lang.number_of_people_vote}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { choiceset.map((item, key)=>
                                <tr key={key}>
                                    <td>
                                        <div className="vote-color"
                                        style={{backgroundColor: colors[key]}}>
                                        </div>
                                    </td>
                                    <td>{item.choiceValue}</td>
                                    <td>
                                    {item.answer ? 
                                    <FontAwesomeIcon icon={faCheck}/>
                                    : null
                                    }
                                    </td>
                                    <td>{dataset[key]}</td>
                                </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
            
        </div>
    )
}

function Comments(props){
    const notify = useContext(NotifyContext)
    const [page, setPage] = useStateWithCallbackLazy(1)
    const size = 10
    const newsId = props.newsId
    const [comment, setComment] = useState([])
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.news

    const fetchComment = (page, size, newsId) =>{
        listCommment(page, size, newsId,
            (data)=>{
                setComment(data)
            },
            (error)=>{

            })
    }

    const deleteCommentFromNews = (commentId) =>{
        if(window.confirm(lang.sure_to_delete)){
            deleteComment(commentId,
                ()=>{
                    fetchComment(page, size, newsId)
                    notify.showNotify(lang.delete_comment_success, lang.delete_comment_success_desc, 0)
                },
                (error)=>{
                    notify.showNotify("Something wrong", error.message, 2)
                })
        }
    } 

    useEffect(()=>{
        fetchComment(page, size, newsId)
    },[])

    const prevClick = () =>{
        setPage(page - 1, (current)=>{
            fetchComment(current, size, newsId)
        })
    }

    const nextClick = () =>{
        setPage(page + 1, (current)=>{
            fetchComment(current, size, newsId)
        })
    }

    return(
        <div className="comment-container">
            { comment.map((item, key)=>
            <CommentItem
            key={key}
            name={item.username}
            comment={item.comment}
            profileImage={item.profileImagePath}
            date={item.createdDate}
            onClickDelete={()=>deleteCommentFromNews(item.id)}
            />
            )}
            { comment.length === 0 ?
            <div className="no-comment">
                <FontAwesomeIcon icon={faComment} className="icon"/>
                <div>{lang.no_comment}</div>
            </div>
            : null
            }
            <div style={{marginTop: 40}}>
                <Pagination>
                    <Pagination.Prev 
                    disabled={page === 1 ? true:false}
                    onClick={()=>prevClick()}/>
                    <Pagination.Item disabled>
                        {page}
                    </Pagination.Item>
                    <Pagination.Next 
                    disabled={comment.length < size ? true:false}
                    onClick={()=>nextClick()}
                    />
                </Pagination>
            </div>
        </div>
    )
}

function CommentItem(props){

    const convertDate = (toDate) =>{
        let date = new Date(toDate)
        let formatted = dayjs(date).format("D MMMM YYYY H:mm")
        return formatted
    }

    return(
        <div className="comment-item">
            <div className="comment-content-item">
                <div className="image">
                    { props.profileImage !== "" && props.profileImage !== null ? 
                    <img src={props.profileImage} alt={props.profileImage}/>
                    :
                    <FontAwesomeIcon icon={faUserCircle} className="icon"/>
                    }
                </div>
                <div>
                    <div className="name">{props.name}</div>
                    <div className="comment">{props.comment}</div>
                    <div className="date">{convertDate(props.date)}</div>
                </div>
            </div>
            <div className="content-button">
                <Button 
                variant="danger" size="sm"
                onClick={props.onClickDelete}
                >
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>
            </div>

        </div>
    )
}

function UserItem(props){
    return(
        <div className="user-item">
            <div className="image">
                { props.profileImage !== "" && props.profileImage !== null ? 
                <img src={props.profileImage} alt={props.profileImage}/>
                :
                <FontAwesomeIcon icon={faUserCircle} className="icon"/>
                }
            </div>
            <div>
                <div className="title">{props.name}</div>
                <div className="desc">{props.email}</div>
            </div>
            
        </div>
    )
}

export default View
